import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MeetingPage } from './meeting';
import { MomentModule } from 'ngx-moment';
import {DepositPaymentMethodModal} from "./deposit-payment-method-modal/deposit-payment-method-modal";
import {DepositPaymentMethodModalModule} from "./deposit-payment-method-modal/deposit-payment-method-modal.module";

@NgModule({
  declarations: [
    MeetingPage,
  ],
  imports: [
    IonicPageModule.forChild(MeetingPage),
    MomentModule,
    DepositPaymentMethodModalModule
  ],
  exports: [DepositPaymentMethodModalModule],
  entryComponents: [DepositPaymentMethodModal]
})
export class MeetingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/meeting/meeting.module.ts